var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsExceptedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "#FA5A7C",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6906 8.04616C22.9094 8.30149 23.7016 9.54379 23.4578 10.8205L23.35 11.3802C23.1016 12.6913 22.6422 13.9385 22 15.0728H28.75C29.9922 15.0728 31 16.1285 31 17.4297C31 18.3381 30.5078 19.1286 29.7859 19.5215C30.2969 19.9536 30.625 20.6165 30.625 21.3579C30.625 22.5069 29.8375 23.4644 28.8016 23.6707C29.0078 24.0291 29.125 24.4465 29.125 24.8933C29.125 25.9392 28.4734 26.828 27.5734 27.1324C27.6062 27.2944 27.625 27.4663 27.625 27.6431C27.625 28.9443 26.6172 30 25.375 30H20.8047C19.9141 30 19.0469 29.725 18.3062 29.2094L16.5016 27.9475C15.25 27.0735 14.5 25.6004 14.5 24.0242V22.1436V19.7866V18.564C14.5 17.1302 15.1234 15.7798 16.1875 14.8813L16.5344 14.5916C17.7766 13.5506 18.625 12.0873 18.9344 10.4571L19.0422 9.89733C19.2859 8.62066 20.4719 7.79082 21.6906 8.04616ZM8.5 15.8584H11.5C12.3297 15.8584 13 16.5606 13 17.4297V28.4287C13 29.2978 12.3297 30 11.5 30H8.5C7.67031 30 7 29.2978 7 28.4287V17.4297C7 16.5606 7.67031 15.8584 8.5 15.8584Z",
    fill: "#FEFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsExceptedIcon);
export default __webpack_public_path__ + "static/media/isExcepted-icon.712826b5dcbe928d1ff61889422d7832.svg";
export { ForwardRef as ReactComponent };